/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { toHeaderCase } from "js-convert-case";
import config from "../config/portfolio.template.form.json";

export interface IPortfolioFormMethods extends IPluginMethodMap {
  getPortfolioFormProps(args: any): Promise<any>;
}

export class PortfolioFormService implements IAgentPlugin {
  readonly methods: IPortfolioFormMethods;

  constructor() {
    this.methods = {
      getPortfolioFormProps: this.getProps.bind(this),
    };
  }

  async getProps(args: any) {
    //   const graphqlModule = getGraphQLModule();
    //   const client = graphqlModule.getClient("graphql-gateway");
    //   const { id } = useCredId();
    try {
      return {
        templatesCount: config?.credentialTemplates?.length,
        templates: this.getTemplateForm(),
        steps: this.getSteps(),
      };
    } catch (err: any) {
      return err;
    }
  }

  private getSteps() {
    let steps: any = [];
    if (
      Array.isArray(config?.credentialTemplates) &&
      config?.credentialTemplates?.length > 0
    ) {
      config?.credentialTemplates.forEach((element) => {
        steps.push({ label: element?.name });
      });
    }
    return steps;
  }

  private getTemplateForm() {
    let formData: any = [];
    if (
      Array.isArray(config?.credentialTemplates) &&
      config?.credentialTemplates?.length > 0
    ) {
      config?.credentialTemplates.forEach((element) => {
        formData.push({
          credentialLogo: element?.logo,
          credentialId: element?.id,
          credentialDescription: element?.description,
          credentialFields: element?.jsonFormat?.credential,
          submitButtonLabel: config?.submitButtonTitle,
          credentialName: this.formatName(element?.name),
        });
      });
    }
    return formData;
  }

  private formatName(name: string) {
    if (name) {
      return toHeaderCase(name);
    }
  }
}
